
export const TextField = ({ title, value, iconUrl }) => {
    return (
        <div className="flex items-center gap-1">
            <div className="min-w-[50px] min-h-[50px] bg-blue-100 rounded-xl flex items-center justify-center overflow-hidden">
                {iconUrl ? (
                    <img
                        src={iconUrl}
                        alt="date picker Icon"
                        className="w-[17px] h-[17px]"
                    />
                ) : (
                    // Placeholder circle or initials
                    <div className="min-w-[50px] min-h-[50px] bg-light-purple rounded-[10px]" />
                )}
            </div>
            <div>
                <div className="text-size-14 text-[#15194B] font-regular mt-[2px]">{title || ""}</div>
                <div className="text-size-14 font-semibold text-black">{value || ""}</div>
            </div>
        </div>
    );
};
